import React from "react";

import Tabs from "components/ui/tabs/Tabs";
import AutomationsList from "features/admin/automation/AutomationsList";
import CompanyManagement from "features/admin/company-management/CompanyManagement";
import LeadHunter from "features/admin/lead-hunter/LeadHunter";
import AdminStatistics from "features/admin/statistics/AdminStatistics";
import SuiteEvents from "features/admin/suite-events/SuiteEvents";
import TrackingDiagnostics from "features/admin/tracking/TrackingDiagnostics";

const Admin = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let adminTabs = [];

  adminTabs.push({
    label: "Şirket Yönetimi",
    content: <CompanyManagement />,
  });

  adminTabs.push({
    label: "Otomatik İşlemler",
    content: <AutomationsList />,
  });

  adminTabs.push({
    label: "Lead Hunter",
    content: <LeadHunter />,
  });

  adminTabs.push({
    label: "İstatistikler",
    content: <AdminStatistics />,
  });

  adminTabs.push({
    label: "Suite Events",
    content: <SuiteEvents />,
  });

  adminTabs.push({
    label: "Canlı Takip Teşhis",
    content: <TrackingDiagnostics />,
  });

  return (
    <React.Fragment>
      <Tabs tabs={adminTabs} tabValue={tabValue} onTabChange={handleTabChange} isVertical={true} />
    </React.Fragment>
  );
};

export default Admin;
